import { apiClient } from '@/services/api';
import type { Deal, DealClickResponse, DealsIndexResponse } from '@/types/deal';

export const dealsService = {
  /**
   * Full index envelope: the deals array plus the top-level `bonus_promo`
   * banner payload (null unless a referral payout boost is live). `?? null`
   * normalizes older servers that don't send the key yet.
   */
  async list(): Promise<DealsIndexResponse> {
    const response = await apiClient.get<DealsIndexResponse>('/api/v1/deals');
    return { deals: response.deals, bonus_promo: response.bonus_promo ?? null };
  },

  async show(slug: string): Promise<Deal> {
    const { deal } = await apiClient.get<{ deal: Deal }>(
      `/api/v1/deals/${encodeURIComponent(slug)}`,
    );
    return deal;
  },

  /**
   * Records a click and returns the brand's redirect URL. Server is naturally
   * idempotent: it reuses the existing Action for this user+deal if one
   * exists, or creates a new one otherwise. The returned `click_id` is the
   * Action's UUID — pass it through to PerformCB tracking parameters in the
   * redirect URL (server already does this).
   */
  async click(slug: string): Promise<DealClickResponse> {
    return apiClient.post<DealClickResponse>(
      `/api/v1/deals/${encodeURIComponent(slug)}/click`,
    );
  },
};
